// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-layout-partials-component-template-js": () => import("./../src/layout/partials/ComponentTemplate.js" /* webpackChunkName: "component---src-layout-partials-component-template-js" */),
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

